import HideChordsPlugin from './HideChordsPlugin';

export default HideChordsPlugin;
